<template>
    <div class="language-container" @click="openSelect">
        <ion-icon src="assets/icon/globe.svg" :class="colors" class="language-dropdown-icon"/>
        <ion-select
            ref="selectEl"
            :cancel-text="$t('button.cancel')"
            interface="action-sheet"
            v-model="language"
            @ion-change="selectChangeFunction"
            class="language-dropdown"
            :class="colors"
            :selected-text="language.toString().toUpperCase()"
            mode="ios"
        >
            <ion-select-option v-for="lang of APP_LANGUAGES" :key="lang" :value="lang">
                <span
                    v-if="Capacitor.isNativePlatform()"
                    v-html="toFlagHexCode(lang)"
                />
                {{ lang.toString().toUpperCase() }}
            </ion-select-option>
        </ion-select>
    </div>
</template>

<script setup lang="ts">
import { IonIcon, IonSelect, IonSelectOption } from "@ionic/vue";
import { ref, watch } from "vue";
import { route } from "@/router";
import i18n, { changeLanguage } from "@/plugins/vue-i18n";
import { Capacitor } from "@capacitor/core";

import { toFlagHexCode } from "@/functions/converter";

import { APP_LANGUAGES } from "@/types/enum/ionicEnum";
import { LanguageDropdownProps } from "@/types/props";

const props = withDefaults(defineProps<LanguageDropdownProps>(), {
    colors: 'coral-light-color'
})

const selectEl = ref()

function openSelect() {
    selectEl.value.$el.click()
}

const language = ref<APP_LANGUAGES>(
    route.value.query.lang ?
        route.value.query.lang :
        (
            //Not supported
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            i18n.global.locale.value ?? Object.values(APP_LANGUAGES)[0]
        )
)

watch(props, () => { if (props.language) language.value = props.language })

const selectChangeFunction = (): void => {
    if (props.changeFunction) {
        props.changeFunction(language.value)
    } else {
        changeLanguage(language.value)
    }
}
</script>

<style scoped>
.language-container {
    display: flex;
    align-items: center;
    gap: 5px;
    padding-left: 12px;
    border: var(--color, #000) 1px solid;
    border-radius: 5px;
}

.language-dropdown {
    width: max-content;
    border-radius: 5px;
    padding-right: 12px;
    --padding-start: 0;
    --ion-color-step-650: var(--color, #000);
}

.language-dropdown::part(text) {
    margin-bottom: -0.1875em;
}

.language-dropdown-icon {
    width: 20px;
    height: 20px;
}
</style>

<style>
.language-dropdown .select-interface-option.item-radio-checked {
    --background: var(--ion-color-grey3)
}
</style>
